export const vendorOptions = [
  "General Contractor & Builders",
  "Landscape",
  "Irrigation",
  "Exteriors Building & Repair",
  "Exteriors Cleaning",
  "Flooring",
  "Painting Services",
  "Handyman",
  "Carpentry",
  "Plumbing",
  "Electrician",
  "HVAC",
  "Pest Control",
  "Housekeeping & Cleaning",
  "Carpet & Upholstery",
  "Pool Services",
  "Appliances / Small Electronics",
  "Other"
].map((option) => ({ label: option, value: option }));
